import { connect } from 'react-redux'
import React, { Component } from 'react'
import { Card, CardTitle, CardText, Divider } from 'react-md'
import { Link } from 'react-router-dom'

import { getShopifySmartCollectionURL } from 'lib/uri'
import { getAuthUser, getArtworkCount } from 'redux/reducers'
import * as actions from 'redux/actions'
import * as routes from 'routes'

import './index.css'

class ArtistHome extends Component {
  componentWillMount () {
    const { loadArtworkCount } = this.props
    loadArtworkCount()
  }

  render () {
    const { authUser, artworkCount } = this.props

    const profileURL =
      getShopifySmartCollectionURL(authUser.shopifyCollectionHandle)

    return (
      <div>
        <Card>
          <CardTitle title='Welcome to arthaus' />
          <CardText>
            You have {artworkCount} artworks.

            <br /><br />

            Your Store URL is: <Link to={profileURL} target='_blank'>
              { profileURL }
            </Link>

            <br /><br />

            <Divider />

            <br />

            To upload your art and start selling,
            <Link to={routes.upload()}> click here</Link>.

            <br /><br />

            You can upload multiple artworks at the same time, and edit titles,
            descriptions and commissions on the fly, while they are uploading.
            Try it out by adding 10-20 artworks at once and editing on the fly!

            <br /> <br />

            Once your art is up and you are happy with the titles and
            descriptions, hit "Request Publishing" to add your work to the
            arthaus store. Our team will quickly review it before making it
            live - this can take up to 24 hours. If you need to make changes
            you will need to unpublish, edit as necessary, then request to
            publish again. These checks are necessary to create the best user
            experience for our customers.

            <br /> <br />

            Finally, don’t forget to add
            a <Link to={routes.account()}>profile picture</Link> and
            an <Link to={routes.account()}>artist bio</Link> along
            with a PayPal address so you can get paid.
          </CardText>
        </Card>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  artworkCount: getArtworkCount(state),
  authUser: getAuthUser(state)
})

export default connect(mapStateToProps, actions)(ArtistHome)



// WEBPACK FOOTER //
// ./src/containers/ArtistHome/index.js